import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type UpdateWebsitePageContainerPrivacyMutationVariables = Types.Exact<{
  payload: Types.PageContainerUpdatePayload;
}>;

export type UpdateWebsitePageContainerPrivacyMutation = {
  __typename?: 'Mutation';
  updatePageContainer: { __typename?: 'PageContainer'; id: string; visibility: Types.EventPageVisibility; labelIds: Array<string>; personIds: Array<string> };
};

export type UpdateWebsiteEventPagePrivacyMutationVariables = Types.Exact<{
  pageId: Types.Scalars['ID'];
  payload: Types.UpdateEventPagePayload;
}>;

export type UpdateWebsiteEventPagePrivacyMutation = {
  __typename?: 'Mutation';
  updateEventPage: { __typename?: 'EventPage'; id: string; visibility: Types.EventPageVisibility; disabled: boolean; private: boolean };
};

export type UpdateWebsiteSectionPrivacyMutationVariables = Types.Exact<{
  sectionId: Types.Scalars['ID'];
  input: Types.CarbonWebsiteUpdateSectionInput;
}>;

export type UpdateWebsiteSectionPrivacyMutation = {
  __typename?: 'Mutation';
  carbonWebsiteUpdateSection: { __typename?: 'CarbonWebsiteSiteSection'; id: string; hidden: boolean; inNav: boolean; visibility: string; visibilityOptions: Array<string> };
};

export const UpdateWebsitePageContainerPrivacyDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateWebsitePageContainerPrivacy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageContainerUpdatePayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePageContainer' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                { kind: 'Field', name: { kind: 'Name', value: 'labelIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'personIds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateWebsitePageContainerPrivacyMutationFn = Apollo.MutationFunction<UpdateWebsitePageContainerPrivacyMutation, UpdateWebsitePageContainerPrivacyMutationVariables>;

/**
 * __useUpdateWebsitePageContainerPrivacyMutation__
 *
 * To run a mutation, you first call `useUpdateWebsitePageContainerPrivacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsitePageContainerPrivacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsitePageContainerPrivacyMutation, { data, loading, error }] = useUpdateWebsitePageContainerPrivacyMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateWebsitePageContainerPrivacyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWebsitePageContainerPrivacyMutation, UpdateWebsitePageContainerPrivacyMutationVariables>,
) {
  return ApolloReactHooks.useMutation<UpdateWebsitePageContainerPrivacyMutation, UpdateWebsitePageContainerPrivacyMutationVariables>(
    UpdateWebsitePageContainerPrivacyDocument,
    baseOptions,
  );
}
export type UpdateWebsitePageContainerPrivacyMutationHookResult = ReturnType<typeof useUpdateWebsitePageContainerPrivacyMutation>;
export type UpdateWebsitePageContainerPrivacyMutationResult = Apollo.MutationResult<UpdateWebsitePageContainerPrivacyMutation>;
export type UpdateWebsitePageContainerPrivacyMutationOptions = Apollo.BaseMutationOptions<
  UpdateWebsitePageContainerPrivacyMutation,
  UpdateWebsitePageContainerPrivacyMutationVariables
>;
export const UpdateWebsiteEventPagePrivacyDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateWebsiteEventPagePrivacy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateEventPagePayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEventPage' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'pageId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'private' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateWebsiteEventPagePrivacyMutationFn = Apollo.MutationFunction<UpdateWebsiteEventPagePrivacyMutation, UpdateWebsiteEventPagePrivacyMutationVariables>;

/**
 * __useUpdateWebsiteEventPagePrivacyMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteEventPagePrivacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteEventPagePrivacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteEventPagePrivacyMutation, { data, loading, error }] = useUpdateWebsiteEventPagePrivacyMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateWebsiteEventPagePrivacyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWebsiteEventPagePrivacyMutation, UpdateWebsiteEventPagePrivacyMutationVariables>,
) {
  return ApolloReactHooks.useMutation<UpdateWebsiteEventPagePrivacyMutation, UpdateWebsiteEventPagePrivacyMutationVariables>(UpdateWebsiteEventPagePrivacyDocument, baseOptions);
}
export type UpdateWebsiteEventPagePrivacyMutationHookResult = ReturnType<typeof useUpdateWebsiteEventPagePrivacyMutation>;
export type UpdateWebsiteEventPagePrivacyMutationResult = Apollo.MutationResult<UpdateWebsiteEventPagePrivacyMutation>;
export type UpdateWebsiteEventPagePrivacyMutationOptions = Apollo.BaseMutationOptions<UpdateWebsiteEventPagePrivacyMutation, UpdateWebsiteEventPagePrivacyMutationVariables>;
export const UpdateWebsiteSectionPrivacyDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateWebsiteSectionPrivacy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sectionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CarbonWebsiteUpdateSectionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carbonWebsiteUpdateSection' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'sectionId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sectionId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hidden' } },
                { kind: 'Field', name: { kind: 'Name', value: 'inNav' } },
                { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                { kind: 'Field', name: { kind: 'Name', value: 'visibilityOptions' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateWebsiteSectionPrivacyMutationFn = Apollo.MutationFunction<UpdateWebsiteSectionPrivacyMutation, UpdateWebsiteSectionPrivacyMutationVariables>;

/**
 * __useUpdateWebsiteSectionPrivacyMutation__
 *
 * To run a mutation, you first call `useUpdateWebsiteSectionPrivacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsiteSectionPrivacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebsiteSectionPrivacyMutation, { data, loading, error }] = useUpdateWebsiteSectionPrivacyMutation({
 *   variables: {
 *      sectionId: // value for 'sectionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebsiteSectionPrivacyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWebsiteSectionPrivacyMutation, UpdateWebsiteSectionPrivacyMutationVariables>,
) {
  return ApolloReactHooks.useMutation<UpdateWebsiteSectionPrivacyMutation, UpdateWebsiteSectionPrivacyMutationVariables>(UpdateWebsiteSectionPrivacyDocument, baseOptions);
}
export type UpdateWebsiteSectionPrivacyMutationHookResult = ReturnType<typeof useUpdateWebsiteSectionPrivacyMutation>;
export type UpdateWebsiteSectionPrivacyMutationResult = Apollo.MutationResult<UpdateWebsiteSectionPrivacyMutation>;
export type UpdateWebsiteSectionPrivacyMutationOptions = Apollo.BaseMutationOptions<UpdateWebsiteSectionPrivacyMutation, UpdateWebsiteSectionPrivacyMutationVariables>;
